import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const EssendonFieldsPage = () => (
  <LocationTemplate suburbName="Essendon Fields" suburbSlug="essendon-fields" />
);

export default EssendonFieldsPage;
